module.exports = __webpack_public_path__ + "img/mobile-localization.088625d0.svg";